import React from 'react'
import OldNativeVersionDialogDialog from './Dialog'
import { SHOW_ONLY_ONCE_KEY } from './constants'
import { useOldNativeVersionDialog } from './useOldNativeVersionDialog'

const OldNativeVersionDialog: React.FC<{ showOnlyOnce?: boolean }> = ({ showOnlyOnce }) => {
  const { setShowDialog, nativeVersion, showDialog, platformText } = useOldNativeVersionDialog({
    showOnlyOnce: Boolean(showOnlyOnce),
  })

  if (!nativeVersion) return null

  return (
    <OldNativeVersionDialogDialog
      open={showDialog}
      onClose={() => {
        setShowDialog(false)
        if (showOnlyOnce) {
          localStorage.setItem(SHOW_ONLY_ONCE_KEY, 'true')
        }
      }}
      platform={platformText}
    />
  )
}

export default OldNativeVersionDialog
